import { IVideoYoutube } from 'models/IVideoYoutube';

const apiKey = 'AIzaSyD2uMWHXa3b3dZ_xWNJTTGaZQWvt4pOsFo';
const apiURL = 'https://www.googleapis.com/youtube/v3';

export const searchVideos = async (terms: string) => {
  const endpointSearch = `${apiURL}/search?part=snippet&type=video&maxResults=10&q=${terms}`;
  const res = await fetch(`${endpointSearch}&key=${apiKey}`);
  const json = await res.json()

  return (json['items'] as Array<IVideoYoutube>)
}
